
import { companyListAwaitExpiredReducer } from "../reducer/CompanyListAwaitExpiredReducer";

export const reducer = companyListAwaitExpiredReducer;